import Component from "vue-class-component";
import Vue from "Vue";

@Component
export default class Title extends Vue {}



// WEBPACK FOOTER //
// ./src/shared/components/Title/Title.ts